module.exports = __webpack_public_path__ + "static/img/sspzz_2x.1602d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspzz_2x.png
// module id = h6wu
// module chunks = 1